export default __webpack_public_path__ + "static/media/Rectangle-1.f9c2fbd0.png";